import { useMemo, useState } from "react";
import { Badge, Button, Card, Checkbox, Modal, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { ProductInterface } from "../../../../interfaces/product";
import { EditTwoTone, ExclamationCircleOutlined } from "@ant-design/icons";
import "./styles.css";
import EditProduct from "./EditProduct";
import { formatCurrency } from "../../../../utils";
import { api } from "../../../../config";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../../interfaces/users";
import { toast } from "react-toastify";
import { useQueries } from "react-query";
import { CheckboxChangeEvent } from "antd/lib";
interface ProductsProps {
  products: ProductInterface[];
  ticketId: number;
  externalId?: number;
  additions?: any[]
}

const Products = ({ products, ticketId, externalId, additions }: ProductsProps) => {
  const { token, user } = useSelector((state: AuthenticationState) => state);
    const [{ isFetching, refetch }]: any = useQueries([
      { queryKey:`tickets/assemble`,
      queryFn: () => api(token).get(`ticket/assemble/${ticketId}`),
      refetchOnMount: false
    },
      
  ]);
  const [showEditModal, setShowEditModal] = useState(false);

const [selectedProducts, setSelectedProducts] = useState<number[]>([])
const [splitLoading, setSplitLoading] = useState(false)

  const handleChangeCheckbox = (e: CheckboxChangeEvent) => {
    const {id, checked } = e.target

    if (checked) {
      setSelectedProducts(prev => Array.from(new Set([...prev, Number(id)])))
    } else {
      setSelectedProducts(prev => prev.filter(item => item !== Number(id) ))
    }
  }


  const handleSplitOs = async () => {

    try {
      setSplitLoading(true)
      await api(token).post('ticket/split-field-report', {productIds: selectedProducts, fieldReportId: ticketId})
    } catch (error) {
      toast.error('Ocorreu um erro ao desmembrar ticket')
    } finally {
      setSplitLoading(false)
    }
    setSelectedProducts([])
    refetch()
  }

  const columns: ColumnsType<ProductInterface> = [
    {title: 'Selecionar',
      dataIndex: 'fieldReportProductId',
      key: 'fieldReportProductId',
      render: (fieldReportProductId: number) => {
       
        return (
          <Checkbox id={`${fieldReportProductId}`} onChange={handleChangeCheckbox} />
        ) 
      },
      width: 50,

    },
    {
      title: "Descrição",
      dataIndex: "description",
      key: "description",
      width: 500,
    },
    {
      title: "Quantidade",
      dataIndex: "quantity",
      key: "quantity",
      render: (quantity: number) => `${quantity} UN`,
    },
    {
      title: "Valor Unitário",
      dataIndex: "value",
      key: "value",
      render: (value: any) => formatCurrency(value),
    },
    {
      title: "Editar",
      key: "edit",
      render: (_, record) => {
        return !!!(
          record.seniorityId &&
          record.assemblyTime &&
          record.externalId
        ) ? (
          <Badge
            count={
              <ExclamationCircleOutlined
                style={{ color: "#f5222d", fontSize: 16 }}
              />
            }
          >
            {" "}
            <Button
              type="link"
              title="Necessita Cadastro"
              disabled={
                !!(
                  record.seniorityId &&
                  record.assemblyTime &&
                  record.externalId
                )
              }
              onClick={() => setShowEditModal(true)}
              icon={<EditTwoTone />}
              size={"middle"}
            />{" "}
          </Badge>
        ) : (
          <Button
            type="link"
            icon={<EditTwoTone />}
            size={"middle"}
            onClick={() => setShowEditModal(true)}
          />
        );
      },
    },
  ];

  const handleUpdateProducts = async () => {
    try {
      const response = await api(token).get(`ticket/update-products/${externalId}`)
      refetch()
    } catch (error) {
      toast.error("Ocorre um erro ao Atualizar os produtos")
    }
  }

  const totalProducts = useMemo(() => products?.reduce((acc, current) => acc += current.value, 0) ?? 0, [products])
  const totalAdditions = useMemo(() => additions?.reduce((acc, current) => acc += current.value, 0) ?? 0, [additions])


  return (
    <div>
      {showEditModal && (
        <Modal
          open={showEditModal}
          onCancel={() => setShowEditModal(false)}
          footer={null}
          width="50%"
        >
          <EditProduct
            onSave={() => {
              refetch()
              setShowEditModal(false)
            }}
            onCancel={() => setShowEditModal(false)}
            products={products}
            ticketId={ticketId}
          />
        </Modal>
      )}

      <Card
        title={
          <div>
            <p>{`Produtos: ${formatCurrency(totalProducts)} ${
              additions?.length
                ? `  -|-  Adicionais: ${formatCurrency(
                    totalAdditions
                  )}  -|-  Total OS: ${formatCurrency(
                    totalProducts + totalAdditions
                  )}`
                : ""
            }`}</p>
            <div className="flex w-full justify-between mb-1">
            <Button loading={isFetching} onClick={handleUpdateProducts}>
              Atualizar produtos
            </Button>

            <Button loading={splitLoading} disabled={products?.length < 2 || !selectedProducts?.length} onClick={handleSplitOs}>
              Desmembrar OS
            </Button>
            </div>
          </div>
        }
        size="small"
        headStyle={{ color: "rgb(59 130 246)" }}
      >
        <Table
          className=" overflow-auto"
          size="small"
          columns={columns}
          dataSource={products}
          pagination={false}
          style={{ maxHeight: "25vh" }}
        />
      </Card>
    </div>
  );
};

export default Products;
